module.exports = __webpack_public_path__ + "img/MS-LOGO-1-blue.e3be99a4.png";